import { AppAuthService } from 'src/app/_services/app-auth.service';
import { SidenavService } from '../../_services/sidenav.service';
import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { SidenavLink } from '../../_models/SidenavLink';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { AuthService } from '@auth0/auth0-angular';
import { AuthButtonComponent } from 'src/app/auth/auth-button/auth-button.component';
import { takeUntilDestroyed, toObservable } from '@angular/core/rxjs-interop';

@Component({
    selector: 'app-sidenav-list',
    templateUrl: './sidenav-list.component.html',
    styleUrls: ['./sidenav-list.component.css'],
    standalone: true,
    imports: [MatListModule, MatIconModule, CommonModule, RouterModule, MatButtonModule, AuthButtonComponent],
})
export class SidenavListComponent implements OnInit, OnDestroy {
    @Output() closeSidenav = new EventEmitter<void>();
    links: any[] = [];
    linksSub: Subscription;

    navLinks: any[] = [];
    navLinksSub: Subscription;

    constructor(private _router: Router,
        private _sidenavService: SidenavService,
        private _appAuthService: AppAuthService,
        public auth: AuthService
    ) {
        toObservable(this._appAuthService.isLoggedIn)
            .pipe(takeUntilDestroyed())
            .subscribe((isLoggedIn) => {
                if (isLoggedIn) this._sidenavService.updateLinks([]);
            });
    }

    ngOnInit() {
        this.linksSub = this._sidenavService.sectionLinksSub.subscribe((links: any[]) => {
            this.links = links;
        });

        this.navLinksSub = this._sidenavService.navLinksSub.subscribe((links: SidenavLink[]) => {
            this.navLinks = links;
        });

    }

    ngOnDestroy() {
        this.linksSub.unsubscribe();
        this.navLinksSub.unsubscribe();
    }

    onClose() {
        this.closeSidenav.emit();
    }

      signUp() {
        this._router.navigate(['/signup']);
    }
}
